import { render, staticRenderFns } from "./PageEditTabAccount.vue?vue&type=template&id=0b57ad12&"
import script from "./PageEditTabAccount.vue?vue&type=script&lang=js&"
export * from "./PageEditTabAccount.vue?vue&type=script&lang=js&"
import style0 from "./PageEditTabAccount.vue?vue&type=style&index=0&id=0b57ad12&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports